<template>
  <v-layout column>
    <input-image @image="onImage" :image="resource.form.picture_path" />

    <v-divider class="my-4 divider-primary" />

    <h2>Identificação da Mochila e das Tags</h2>
    <h3 class="text-secondary">Identification of Backpack and Tags</h3>

    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md6>
        <v-text-field outline v-model="resource.form.first_tag" :rules="[rules.required]" label="NOME/NAME" />
      </v-flex>

      <v-flex d-flex xs12 sm6 md6>
        <v-text-field outline v-model="resource.form.last_tag" :rules="[rules.required]" label="SOBRENOME/LASTNAME" />
      </v-flex>
    </v-layout>

    <v-divider class="mb-4" />

    <h2>Informações do aluno para cadastro</h2>
    <h3 class="text-secondary">Student Information for Registration</h3>

    <v-text-field outline v-model="resource.form.name" :rules="[rules.required]" label="NOME E SOBRENOME/ FULL NAME" />

    <v-layout row wrap>
      <v-flex d-flex xs12 sm4 md4>
        <v-text-field outline v-model="birthday" :rules="[rules.required, rules.date]" mask="##/##/####"
          return-masked-value placeholder="dd/mm/yyyy" label="DATA DE NASCIMENTO/DATE OF BIRTH" />
      </v-flex>

      <v-flex d-flex xs12 sm4 md4>
        <v-select :items="genders" outline item-text="name" item-value="id" :rules="[rules.required]"
          :loading="!genders.length" :disabled="!genders.length" v-model="resource.form.gender_id"
          label="SEXO/GENDER" />
      </v-flex>

      <v-flex d-flex xs12 sm4 md4>
        <v-select :items="raceColors" outline v-model="resource.form.race_colors" label="RAÇA/COR/RACE/COLOR" />
      </v-flex>
    </v-layout>

    <v-text-field v-if="isCustomGender" outline v-model="resource.form.custom_gender" :rules="[rules.required]"
      label="OUTRO/OTHER" />

    <v-layout row wrap>
      <v-flex d-flex xs12 sm4 md4>
        <v-text-field outline v-model="resource.form.nationality" label="NACIONALIDADE/NATIONALITY" />
      </v-flex>

      <v-flex d-flex xs12 sm4 md4>
        <v-text-field outline v-model="resource.form.document" label="RG/PASSPORT NUMBER" />
      </v-flex>

      <v-flex d-flex xs12 sm4 md4>
        <v-text-field outline v-model="resource.form.cpf" label="CPF" />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex d-flex xs12 sm4 md8>
        <v-text-field outline v-model="resource.form.address" label="ENDEREÇO COMPLETO/ADDRESS" />
      </v-flex>
      <v-flex d-flex xs12 sm6 md4>
        <v-text-field outline v-model="resource.form.number" label="NÚMERO/NUMBER" />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md3>
        <v-text-field outline v-model="resource.form.city" label="CIDADE/CITY" />
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-select :items="states" outline v-model="resource.form.state" label="ESTADO/STATE" />
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-text-field outline v-model="resource.form.complement" label="COMPLEMENTO/COMPLEMENT" />
      </v-flex>
      <v-flex d-flex xs12 sm6 md3>
        <v-text-field outline v-model="resource.form.zip_code" label="CEP/ZIP CODE" />
      </v-flex>
    </v-layout>
    <v-divider class="divider-primary" />
  </v-layout>
</template>

<script>
import InputImage from '@/components/InputImage'
import * as api from '@/api'
import { formatDateToPtBR, formatDateToDbFormat } from '@/helpers/formatDbDate'
import { date as datePattern } from '@/helpers/regex'

/**
 * @group Form
 * Componente de form para dados de aluno
 */
export default {
  name: 'FormStudent',

  components: {
    InputImage
  },

  inject: ['resource'],

  data: () => ({
    genders: [],
    states: ['Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará', 'Distrito Federal', 'Espírito Santo', 'Goiás', 'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Pará', 'Paraíba', 'Paraná', 'Pernambuco', 'Piauí', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia', 'Roraima', 'Santa Catarina', 'São Paulo', 'Sergipe', 'Tocantins'],
    raceColors: ['Branca', 'Preta', 'Amarela', 'Parda', 'Indígena', 'Não declarada'],
    rules: {
      date: value => {
        return datePattern.test(value) || 'Data inválida/Invalid date'
      },
      required: value => !!value || 'Campo obrigatório/Field is required'
    }
  }),

  computed: {
    resource () {
      return this.resource
    },

    isCustomGender () {
      if (!this.genders.length) return false
      return this.resource.form.gender_id === this.genders[this.genders.length - 1].id
    },

    birthday: {
      get () {
        return formatDateToPtBR(this.resource.form.birthday)
      },

      set (newValue) {
        this.resource.form.birthday = formatDateToDbFormat(newValue)
      }
    }
  },

  mounted () {
    api.forms.information.getGender().then(response => {
      this.processGenderInformation(response.data)
    }).catch(error => {
      throw new Error(error)
    })
  },

  methods: {
    /**
     * @vuese
     * Método responsavél pela ação de submit do formulário
     */
    onImage (image) {
      this.resource.form.picture_path = image
      this.resource.form.picture = { data: image }
    },

    /**
     * @vuese
     * Método para validação da form
     */
    validateForm () {
      return this.$refs.form.validate()
    },

    /**
     * @vuese
     * Método para transformação de dados do genero do estudante
     */
    processGenderInformation (data) {
      data.map(gender => {
        this.genders.push({
          name: gender.name,
          id: gender.id
        })
      })
    }
  }
}
</script>
